import { Expose, Type } from 'class-transformer'
import { Home } from '@material-ui/icons'

import { Address } from './Address'
import { Market } from './Market'
import { Base } from './Base'

export class Facility extends Base {
  static type = 'facility'
  static typeDisplay = 'Facility'
  static icon = Home

  type = Facility.type
  typeDisplay = Facility.typeDisplay
  icon = Facility.icon

  @Expose({ name: 'xid' })
  guid: string = ''

  @Type(() => Market)
  market?: Market

  name: string = ''

  phone?: string

  @Type(() => Address)
  address: Address = new Address()
}
